module.exports = __webpack_public_path__ + "static/media/solid_and_liquid.7ca768f0.png";